import { styled } from 'styled-components';
import { motion } from 'framer-motion';

export const AcceptableWrapper = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
`;

export const AcceptableItem = styled.div`
  width: 100%;
  padding: ${props => props.theme.spaceLg};

  display: flex;
  flex-direction: column;
  gap: 1rem;

  text-align: center;

  background-color: ${props => props.theme.backgroundColor};

  border-radius: ${props => props.theme.borderRadiusMd};

  p {
    color: ${props => (props.$acceptable ? props.theme.success : props.theme.danger)};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    width: 18rem;
  }
`;
